import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import {
  Account,
  Source,
} from '@jaimo-solutions-gmbh/platform-services-module';
import { StoriesService } from 'src/app/services/stories.service';
import { StoriesComponent } from 'src/app/modals/stories/stories.component';
import { getImagePath } from 'src/app/utils/getImagePath';

type StageButtonSize = 'xs' | 'small' | 'medium' | 'large' | 'xl';

@Component({
  selector: 'app-stage-button',
  templateUrl: './stage-button.component.html',
  styleUrls: ['./stage-button.component.scss'],
})
export class StageButtonComponent implements OnInit {
  @Input() size: StageButtonSize = 'medium';
  @Input() account: Account | Source;
  @Input() active?: boolean;
  @Input() disabled: boolean;
  @Input() label: string;
  @Input() border: boolean;
  @Input() hideStory: boolean;
  @Input() loading: boolean;
  @Input() background: string;

  story: boolean;
  @Output() onClick = new EventEmitter<Event>();

  constructor(
    private navCtrl: NavController,
    private modalCtrl: ModalController,
    private storiesSerivce: StoriesService
  ) {}

  ngOnInit() {
    if (this.account)
      this.storiesSerivce.hasStories(this.account.handle).then((has) => {
        this.story = has;
      });
  }

  getImage = (filename?: string) => getImagePath() + filename;

  goToStage() {
    this.navCtrl.navigateForward(
      '/' +
        (this.account instanceof Account
          ? this.account.handle
          : this.account.accountSource.handle),
      {
        animated: false,
      }
    );
  }

  openStories() {
    this.modalCtrl
      .create({
        component: StoriesComponent,
        cssClass: 'stories-modal',
        animated: false,
        componentProps: { account: this.account },
      })
      .then((modal) => modal.present());
  }
}
